export enum EDisplayType {
  USD = 'usd',
  Percent = 'percent',
  number = 'number',
  ShortUSD = 'short',
  ShortVST = 'shortvst',
  VST = 'vst',
  Token = 'token',
  NoTruncating = 'NoTruncating',
}

export enum EPrecision {
  USD = 'USD',
  WEI = 'WEI',
}

export enum EStakingState {
  STAKING = 'staking',
  UNSTAKING = 'unstaking',
}

export interface IStakeUnstake {
  updateState: (state: EStakingState) => void;
  state: EStakingState;
}

export interface IStakingState {
  stakingState: EStakingState;
}

export enum NotConnectedOverlayType {
  NONE = 'none',
  COMPONENT = 'component',
  PAGE = 'page',
  CARD = 'card',
}
